/* assets/nibec-hc-marca.js · Bigbuda T-0817 (17-oct-2026)
   Viste el panel inferior de «Cotizar» (celular y tablet) con el estilo de la marca, sin tocar assets/nibec-hdr-cotizar.js:
   cuando ese script crea el panel (al primer toque en «Cotizar») le pone la clase nibec-hc-sheet--marca y la insignia del
   botón (ícono ámbar sobre tinta) junto al título. Solo se carga si la sección «Cotizar móvil: estilo» está activa
   (sections/nibec-hc-marca.liquid). Sin JavaScript o si falla, el panel queda como en el #151. No mide nada ni toca
   los eventos nibec_hdr_cotizar_*. */
(function () {
  'use strict';
  if (window.__nibecHcMarca) return;
  window.__nibecHcMarca = true;

  function vestir(sheet) {
    if (!sheet || sheet.__marca) return;
    sheet.__marca = true;
    sheet.classList.add('nibec-hc-sheet--marca');
    try {
      var cab = sheet.querySelector('.nibec-hc-sheet__cab');
      var ic = document.querySelector('[data-hc-btn] .nibec-hc__ic');
      if (!cab || !ic) return;
      var chip = document.createElement('span');
      chip.className = 'nibec-hc-sheet__chip';
      chip.setAttribute('aria-hidden', 'true');
      chip.innerHTML = ic.innerHTML;
      cab.insertBefore(chip, cab.firstChild);
    } catch (e) {}
  }

  var ya = document.querySelector('.nibec-hc-sheet');
  if (ya) { vestir(ya); return; }
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].classList && n[j].classList.contains('nibec-hc-sheet')) { vestir(n[j]); mo.disconnect(); return; }
      }
    }
  });
  mo.observe(document.body, { childList: true });
})();
